module.exports = __webpack_public_path__ + "static/media/maclic-background.f9d9ce14.png";